require('sass/blocks/_search-for-profession-with-help.scss');

const React = require('react');
const { connect } = require('react-redux');
const { bindActionCreators } = require('redux');
const formActions = require('react-redux-form').actions;
const optionsActions = require('actions/optionsActions');
import { SelectList } from 'components/SelectList/SelectList';
const PropTypes = require('prop-types');
import { formatText } from 'core/i18n';

const classnames = require('classnames');
const { mustShowCnaeQuestion } = require('utilities/logicByCountry');
import objectOmitKey from '../../utilities/objectOmitKey';

class SearchForProfessionWithHelp extends React.Component {
    constructor(props) {
        super(props);

        this.state = { professionId: null };

        this.onHandleUpdate = this.onHandleUpdate.bind(this);
        this.onHandleUpdateProfession = this.onHandleUpdateProfession.bind(this);
        this.getProfessionCategories = this.getProfessionCategories.bind(this);
        this.getProfessionsWorkfor = this.getProfessionsWorkfor.bind(this);
    }

    componentDidMount() {
        const { userProfile, optionsActions, typeCnaeCno, modelName } = this.props;
        const professionId = userProfile[`${modelName}profession_id`];

        optionsActions.clearSubcategoriesList();
        optionsActions.getCategories(typeCnaeCno); // CNO

        if (professionId) {
            this.setState({
                professionId,
            });
            optionsActions.clearSubcategoriesProfessionsWorkList();
            optionsActions.getSubCategoriesWorkfor(typeCnaeCno, professionId);
        }
    }

    handleChangeProfessionId = value => {
        const { formActions, optionsActions, typeCnaeCno } = this.props;
        formActions.change('userProfile.profession_category', '');
        if (!value) {
            this.setState({ professionId: null });
        } else {
            this.setState({ professionId: null }, () => {
                this.setState({ professionId: value });
            });
        }
        optionsActions.clearSubcategoriesProfessionsWorkList();
        optionsActions.getSubCategoriesWorkfor(typeCnaeCno, value);
    };

    onHandleUpdate() {
        const { userProfile, formActions, handleSave } = this.props;
        formActions.setValidity('userProfile.profession_id', { required: true });
        if (handleSave) {
            handleSave('profession', {
                subcategory: userProfile['profession_category'],
            });
        }
    }

    onHandleUpdateProfession() {
        const { userProfile, handleSave, modelName } = this.props;
        const id = userProfile[`${modelName}profession_id`];
        if (handleSave) {
            handleSave('profession', { id });
        }
    }

    getProfessionCategories() {
        const { typeCnaeCno } = this.props;
        const professionCategories = [];
        const categoryListName = typeCnaeCno === '01' ? 'professionAllCategoriesCNAE' : 'professionAllCategoriesCNO';
        this.props.options.get(categoryListName).map(function (value) {
            professionCategories.push(value.toObject());
        });

        return professionCategories;
    }

    getProfessionsWorkfor() {
        const { typeCnaeCno, category } = this.props;
        const professionsWorkfor = [];
        let professionListName = typeCnaeCno === '01' ? 'professionsWorkforSelfEmployed' : 'professionsWorkforEmployed';

        if (category !== null) {
            professionListName =
                typeCnaeCno === '01' ? 'professionsWorkforSelfEmployedSC' : 'professionsWorkforEmployedSC';
        }

        this.props.options.get(professionListName).map(function (value) {
            professionsWorkfor.push({
                value: value.get('code'),
                label: value.get('name'),
            });
        });

        return professionsWorkfor;
    }

    showSearchForProfession() {
        const { userProfile, typeCnaeCno, disabled, category, onActivityChange } = this.props;
        let professionListName = typeCnaeCno === '01' ? 'professionsWorkforSelfEmployed' : 'professionsWorkforEmployed';

        if (category !== null) {
            professionListName =
                typeCnaeCno === '01' ? 'professionsWorkforSelfEmployedSC' : 'professionsWorkforEmployedSC';
        }
        const isLoading = !this.props.options.get(professionListName).size;

        return this.state.professionId ? (
            <div className="search-for-profession">
                <SelectList
                    profileModel="userProfile.profession_category"
                    name="profession_category"
                    optionsList={this.getProfessionsWorkfor()}
                    clearable={false}
                    label={formatText('cnaeOrCno-ProfessionSearchTitle')}
                    description={formatText('cnaeOrCno-selectProfessionTitle')}
                    searchable={true}
                    required
                    isLoading={isLoading}
                    isUpdated={this.onHandleUpdate}
                    focusAnimated
                    disabled={disabled}
                    validations={{
                        required: () => userProfile.profession_category && userProfile.profession_category.length,
                    }}
                    placeholder={formatText('field-selectAnOption')}
                    onChange={onActivityChange}
                    {...objectOmitKey(this.props, 'onChange')}
                />
            </div>
        ) : null;
    }

    render() {
        const { userProfile, typeCnaeCno, title, placeholder, disabled, modelName, onChange } = this.props;
        const handleChangeProfessionId = this.handleChangeProfessionId;
        const loadingCategories = typeCnaeCno === '01' ? 'isLoadingCnaeSubCategories' : 'isLoadingCnoSubCategories';
        const classNameProffesionWithHelp = classnames({
            'search-for-profession-with-help-question': mustShowCnaeQuestion(),
            'search-for-profession-with-help': !mustShowCnaeQuestion(),
        });

        return (
            <div className={classNameProffesionWithHelp}>
                <SelectList
                    profileModel={`userProfile.${modelName}profession_id`}
                    name="profession_id"
                    optionsList={this.getProfessionCategories()}
                    clearable={false}
                    label={title}
                    placeholder={placeholder}
                    searchable={false}
                    required
                    isLoading={this.props.options.get(loadingCategories)}
                    isUpdated={this.onHandleUpdateProfession}
                    onChange={function (value) {
                        handleChangeProfessionId(value);
                        if (onChange) onChange(value);
                    }}
                    focusAnimated
                    disabled={disabled}
                    validations={{
                        required: () =>
                            userProfile[`${modelName}profession_id`] && userProfile[`${modelName}profession_id`].length,
                    }}
                    {...objectOmitKey(this.props, 'onChange')}
                />
                {this.showSearchForProfession()}
            </div>
        );
    }
}

module.exports.constructor = SearchForProfessionWithHelp;
module.exports.SearchForProfessionWithHelp = connect(
    state => ({
        userProfile: state.userProfile,
        userProfileForm: state.userProfileForm,
        options: state.options,
    }),
    dispatch => ({
        formActions: bindActionCreators(formActions, dispatch),
        optionsActions: bindActionCreators(optionsActions, dispatch),
    })
)(SearchForProfessionWithHelp);

SearchForProfessionWithHelp.defaultProps = {
    typeCnaeCno: '02',
    modelName: '',
    professionalOption: null,
};

SearchForProfessionWithHelp.propTypes = {
    typeCnaeCno: PropTypes.string,
    professionalOption: PropTypes.string,
};
